export const CONTRACT_MESSAGES = {
  cannotDelete: "Contract has tracks with revenue/expenses or is in a sent/paid royalty statement.",
  cannotActivate: "Add at least one payee before activating this contract.",
  cannotUnlink: "Contract has tracks with revenue/expenses or is in a sent/paid royalty statement.",
  cannotEditPayees:
    "Contract has tracks with revenue/expenses or is in a sent/paid royalty statement. Editing payees is locked due to split calculations.",
  associatedTracksWarning: "Changes in this section will affect future statements only.",
} as const;

export const ROYALTY_STATEMENT_MESSAGES = {
  bulkDeleteFinalized:
    "Some of the selected statements have been sent or paid, so they can't be deleted.",
  bulkMarkSentNotDraft: "Only draft statements can be marked as sent.",
  bulkMarkPaidWrongStatus: "Only draft or sent statements can be marked as paid.",
  bulkMarkPaidBelowThreshold:
    "Some of the selected statements don't meet their minimum payment threshold.",
  belowPaymentThreshold: (formattedThreshold: string) =>
    `Balance does not meet the ${formattedThreshold} minimum payment threshold.`,
  belowThresholdNote: (formattedThreshold: string) =>
    `Below the ${formattedThreshold} payout threshold — not payable yet`,
} as const;

export const PAYEE_MESSAGES = {
  cannotDelete:
    "Payee is used in a contract that has tracks with revenue/expenses or is in a sent/paid royalty statement.",
  cannotUnlink: "Unlinking could affect split calculations.",
} as const;

export const REVENUE_MESSAGES = {
  cannotEdit: "Revenue is used in a sent/paid royalty statement.",
  cannotDelete: "Revenue is used in a sent/paid royalty statement.",
  bulkSettleMultipleVendors: "A payment covers statements from one vendor only.",
  bulkSettleAlreadySettled: "Some of the selected statements are already settled.",
  bulkSettleSettling: "Some of the selected statements are still being settled.",
  bulkSettleProcessing: "Some of the selected statements are still processing.",
  bulkSettleNegativeSum:
    "The selected statements add up to a negative amount, so they can't be settled together.",
  bulkSettleSingleCorrection:
    "A correction can't be settled on its own. Select the statement the distributor paid as well.",
  correctionSettlesAutomatically:
    "This is a correction. It will be settled automatically together with the next statement the distributor pays.",
  bulkSettleNegativeTicked:
    "A correction has a negative value, so it can't be settled on its own. Select the statement the distributor paid as well.",
  bulkSettlePaymentExceeds: (formattedAmount: string) =>
    `The payment is ${formattedAmount} more than the selected statements. Select another period, or choose a reason for the difference.`,
  bulkSettleStatementsExceed: (formattedAmount: string) =>
    `The selected statements are ${formattedAmount} more than the payment. Check your selection, or choose a reason for the difference.`,
} as const;

export const RELEASE_MESSAGES = {
  releaseInfoBanner: "Release has tracks included in a sent/paid royalty statement.",
  cannotDelete: "Release has revenue/expenses or is in a sent/paid royalty statement.",
} as const;

export const EXPENSE_MESSAGES = {
  expenseInfoBanner:
    "Expense is used in a sent/paid royalty statement - some changes are restricted.",
  cannotDelete: "Expense is used in a sent/paid royalty statement.",
  invoiceCannotDelete: "Invoice is used in a sent/paid royalty statement.",
} as const;

export const TRACK_MESSAGES = {
  cannotDelete: "Track has revenue/expenses or is in a sent/paid royalty statement.",
  cannotDeleteFromCatalog:
    "Track has revenue linked to another release, expenses, or is in a sent/paid royalty statement.",
  cannotUnlink: "Track has revenue/expenses or is in a sent/paid royalty statement.",
  cannotDeselect:
    "Can't deselect — track has revenue/expenses or is in a sent/paid royalty statement.",
  trackInfoBanner: "Track has revenue or is in a sent/paid royalty statement.",
  unavailableReason: "Track has revenue/expenses or is in a sent/paid royalty statement.",
  contractWarningBanner:
    "Changing a contract will affect future statements only. Track has revenue/expenses or is in a sent/paid royalty statement.",
} as const;
